import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = { class: "form-fields-wrapper" }
const _hoisted_3 = { class: "form-buttons-wrapper" }

import { $api } from "@/services/api";
import { reactive, ref } from "vue";
import { FieldSchema, FormSchema } from "@/models/form";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import NextButton from "@/components/shared/NextButton.vue";
import useValidation from "@/use/validation";
import { Applicant } from "@/models/application";
import { Stipulation } from "@/models/opal";
import { StipulationInputRequest } from "@/models/api";

interface Props {
  applicant: Applicant;
  stip: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SocialSecurityNumberInput',
  props: {
    applicant: {},
    stip: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { validateForm } = useValidation();

let personalInfo = ref({} as any);

const submittingData = ref<boolean>(false);

const schema = reactive<FormSchema>({
  nationalIdNumber: {
    type: "ssn",
    label: "SSN",
    placeholder: "###-##-####",
    required: true,
  } as FieldSchema,
} as FormSchema);

async function submit() {
  submittingData.value = true;
  const valid = validateForm(schema, personalInfo.value);
  if (valid) {
    const request = {
      applicationStipulationId: props.stip?.id,
      applicationId: props?.stip?.applicationId,
      ssnInput: {
        ssn: personalInfo.value?.nationalIdNumber?.split("-")?.join(""),
      },
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(props?.stip?.applicationId, request);

    if (response?.id && response?.id > 0) {
      // updates stip status to pending
      let updatedSSNVerificationStip = props.stip;
      updatedSSNVerificationStip.stipulationStatusId = response.stipulationStatusId;
      updatedSSNVerificationStip.stipulationStatusName = response.stipulationStatusName;
      
			emit("success", updatedSSNVerificationStip);

      submittingData.value = false;
    } else {
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseFormField, {
        modelValue: _unref(personalInfo).nationalIdNumber,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(personalInfo).nationalIdNumber) = $event)),
        schema: schema.nationalIdNumber
      }, null, 8, ["modelValue", "schema"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(NextButton, {
        onClick: submit,
        text: "Submit"
      })
    ])
  ]))
}
}

})